var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { InMemoryCache } from '@apollo/client/core';
import schemaPossibleTypes from '@seek/ca-graphql-schema/possible-types.json';
export const createCache = (_a = {}) => {
    var { possibleTypes: configPossibleTypes = {} } = _a, restCacheOptions = __rest(_a, ["possibleTypes"]);
    return new InMemoryCache(Object.assign({ possibleTypes: Object.assign(Object.assign({}, schemaPossibleTypes), configPossibleTypes) }, restCacheOptions));
};
export default (cacheOptions = {}) => createCache(cacheOptions);
//# sourceMappingURL=cache.js.map